import { render, staticRenderFns } from "./NovoTipoDocumento.vue?vue&type=template&id=61e02c71&scoped=true"
import script from "./NovoTipoDocumento.vue?vue&type=script&lang=js"
export * from "./NovoTipoDocumento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61e02c71",
  null
  
)

export default component.exports